import { render, staticRenderFns } from "./DealShowcase.vue?vue&type=template&id=172c28ec&scoped=true&"
import script from "./DealShowcase.vue?vue&type=script&lang=js&"
export * from "./DealShowcase.vue?vue&type=script&lang=js&"
import style0 from "./DealShowcase.vue?vue&type=style&index=0&id=172c28ec&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172c28ec",
  null
  
)

export default component.exports